import './rule-name.scss';
import { InlineEditInput } from '../../../../shared/inline-edit-input/inline-edit-input';
import React from 'react';
import { EditableRule } from '../../../../../model/EditableRule';
import { FieldMessage } from '../../../../../dtos/error-message.dto';

interface RuleNameProps {
    ruleData?: EditableRule;
    sectionErrors: {[field: string]: FieldMessage};
    handleChange: (name: any, value: any) => void;
}

export const RuleName: React.FC<RuleNameProps> = ({ruleData, sectionErrors, handleChange}) => {

    const getErrorMessage = () => {
      if (!sectionErrors['name']?.isValid) {
          return sectionErrors['name']?.message;
      }

      return '';
    };

    return ruleData?.name ? <InlineEditInput val={ruleData.name}
                                            className={'rule-name-input'}
                                            maxLength={50}
                                            setVal={(value) => handleChange('name', value)}
                                            errorMessage={getErrorMessage()}
                                            disabled={ruleData.isDefault}/> : <></>;
};